var _path, _path2, _path3, _path4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconParkSolidRelationalGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 92,
    viewBox: "0 0 157 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 21,
    width: 135,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0833 67.0834H143.917",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 61.3333C78.5 52.8655 66.0512 46 50.6979 46C35.3446 46 22.8958 52.8655 22.8958 61.3333",
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.104 61.3333C134.104 40.1618 109.21 23 78.5 23C47.7901 23 22.8958 40.1618 22.8958 61.3333",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.104 72.8334C139.523 72.8334 143.917 70.259 143.917 67.0834C143.917 63.9077 139.523 61.3334 134.104 61.3334C128.685 61.3334 124.292 63.9077 124.292 67.0834C124.292 70.259 128.685 72.8334 134.104 72.8334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 72.8334C83.9193 72.8334 88.3125 70.259 88.3125 67.0834C88.3125 63.9077 83.9193 61.3334 78.5 61.3334C73.0807 61.3334 68.6875 63.9077 68.6875 67.0834C68.6875 70.259 73.0807 72.8334 78.5 72.8334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8958 72.8334C28.3151 72.8334 32.7083 70.259 32.7083 67.0834C32.7083 63.9077 28.3151 61.3334 22.8958 61.3334C17.4765 61.3334 13.0833 63.9077 13.0833 67.0834C13.0833 70.259 17.4765 72.8334 22.8958 72.8334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H157V92H0V0Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkSolidRelationalGraph);
export default __webpack_public_path__ + "static/media/icon-park-solid_relational-graph.cf8f3d91b9174043bc604ced41775e57.svg";
export { ForwardRef as ReactComponent };